import React, { createContext, useContext, useState } from 'react';

const DashboardContext = createContext();

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

export const DashboardProvider = ({ children }) => {
  const [dashboardRefreshTrigger, setDashboardRefreshTrigger] = useState(0);

  const refreshDashboard = () => {
    setDashboardRefreshTrigger(prev => prev + 1);
  };

  const value = {
    dashboardRefreshTrigger,
    refreshDashboard
  };

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};